var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_7337)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_7337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_7337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47716 15.5228 0 10 0C4.47716 0 0 4.47716 0 10C0 15.5228 4.47716 20 10 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0002C0 13.7085 2.02083 16.9377 5 18.6668V1.3335C2.02083 3.06266 0 6.29184 0 10.0002Z",
    fill: "#F0263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1.3335V18.646C17.9792 16.9377 20 13.7085 20 10.0002C20 6.29184 17.9792 3.06266 15 1.3335Z",
    fill: "#F0263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5832 10.0001L13.7498 9.5834L14.1665 8.3334L12.9165 8.75009L12.4998 7.91675L11.2498 9.16675L11.6665 6.66675L10.854 7.0834L9.99985 5.41675L9.14566 7.0834L8.33316 6.66675L8.74985 9.16675L7.49985 7.91675L7.08316 8.75009L5.83316 8.3334L6.24985 9.5834L5.4165 10.0001L7.9165 12.0834L7.49985 12.9167L9.58316 12.5001V14.5834H10.4165V12.5001L12.4998 12.9167L12.0832 12.0834L14.5832 10.0001Z",
    fill: "#F0263C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_7337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/Canada.ae2851efa7562e42ecb8a16802c0787b.svg";
export { ForwardRef as ReactComponent };